import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { ServiceSchema } from '../components/StructuredData';
import ServicesSection from '../components/ServicesSection';
import FAQSection from '../components/FAQSection';
import { useCachedTexts } from '../hooks/useCachedTexts';
import './AboutPage.css';

const AboutPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { getText } = useCachedTexts('about_hero');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle hash navigation (e.g., /about#services)
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <div className="about-page">
      <SEO 
        title="About Us - PR & Communications Agency"
        description="Magicomms is a communications agency specializing in strategic consulting for sports, business, entertainment and social sector. PR, media relations and press office."
        keywords="communications agency, strategic consulting, sports PR, sports media relations, press office, corporate communications"
        lang="it"
      />
      <ServiceSchema 
        serviceName="Strategic Communication & PR Services"
        description="Comprehensive communication services including PR strategy, media relations, crisis management, digital content, and brand identity."
      />

      {/* Who Are We Section */}
      <section className="about-hero">
        <div className="about-container">
          <h1>{getText('title', t('about.title'))}</h1>
          <div className="about-hero-content">
            <div className="about-hero-image">
              <img src={`${process.env.PUBLIC_URL}/team.png`} alt="Magicomms Team" />
            </div>
            <div className="about-intro">
              <p style={{ whiteSpace: 'pre-line' }}>{getText('paragraph', t('about.paragraph1'))}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <ServicesSection />

      {/* FAQ Section */}
      <FAQSection />
    </div>
  );
};

export default AboutPage;
